import { createFileRoute } from '@tanstack/react-router';

import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';

export const Route = createFileRoute('/logout')({
  component: LogoutRoute
});

function LogoutRoute() {
  return (
    <>
      <Seo title="Logout" />
      <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
        <Heading>Logout</Heading>
      </div>
    </>
  );
}
